import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appClimateIcon',
})
export class ClimateIconPipe implements PipeTransform {
  private readonly icons: Record<string, string> = {
    temperature: 'bi-thermometer-half',
    humidity: 'bi-droplet',
    co2: 'bi-cloud-fog2',
    windSpeed: 'bi-wind',
  };

  public transform(type: string): string {
    return this.icons[type] || '';
  }
}
